import { gql } from '@lcs/shared/api';

export const runQueueMembers = gql`
   query RunQueueMembers($params: ExecuteTilePostModelQueueMembersTileReportParametersInput!) {
      runQueueMembersTile(params: $params) {
         data {
            members {
               agentName
               availability
               queues
               callCount
               overallTalkTime
               avgCallTime
               callsPerHour
               timeSinceLastCall
               outboundCallCount
               currentTime
               agentExtensionId
               agentExtension
            }
         }
         dashboardTileId
      }
   }
`;
